import { Box } from "@mui/material";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";
import DraggableSelector from "../../../components/draggable-selector";
import { IListItem } from "../../../interface/list-item";
import { IRootState } from "../../../redux/root.reducer";
import { IWithClassName } from "../../../theme/default.theme";
import { FormParams } from "../enums/form-params";
import { Steps } from "../enums/steps";
import { IColumnsForm, IError } from "../interface/form";

const selector = createSelector(
    (state: IRootState) => state.dataFields,
    (state: IRootState) => state.listBuilder.listBuilder.data,
    (dataFields, listBuilder) => ({
        dataFields: {
            options: (dataFields.data ?? [" "]).map((value) => ({
                id: value,
                name: value,
            })),
            selected: listBuilder
                ? listBuilder[FormParams.COLUMNS].map((column) => ({
                      id: column,
                      name: column,
                  }))
                : undefined,
            isLoading: dataFields.isLoading,
        },
        useListColumns: listBuilder?.useListColumns ?? false,
    }),
);

interface IProps extends IWithClassName {
    onSelectChange: (
        step: Steps,
        label: FormParams,
    ) => (options: Array<IListItem>) => void;
    form: IColumnsForm;
    error: IError;
    initStepForm: (step: Steps, form: IColumnsForm) => void;
}

const ColumnLists = ({
    className,
    onSelectChange,
    form,
    error,
    initStepForm,
}: IProps) => {
    const { dataFields, useListColumns } = useSelector(selector);

    useEffect(() => {
        initStepForm(Steps.COLUMN_LISTS, {
            [FormParams.COLUMNS]: dataFields.selected ?? [],
            [FormParams.USE_LIST_COLUMNS]: useListColumns,
        });
    }, [dataFields.selected, useListColumns]);

    return (
        <Box className={className}>
            <DraggableSelector
                options={dataFields.options}
                onChange={onSelectChange(
                    Steps.COLUMN_LISTS,
                    FormParams.COLUMNS,
                )}
                leftBoxHeader="Preferred Column Order"
                rightBoxHeader="Available Data Fields"
                addTitle="Add field(s) to Preferred Data-Fields"
                removeTitle="Remove field(s) from Preferred Data-Fields"
                addAllTitle="Add All field(s) to Preferred Data-Fields"
                removeAllTitle="Remove All field(s) from Preferred Data-Fields"
                selected={form.columns ?? []}
                disabled={form.useListColumns ?? false}
                error={error[FormParams.COLUMNS]}
            />
        </Box>
    );
};

export default ColumnLists;
